@if (form) {
  <form [formGroup]="form">
    <mat-toolbar color="accent">
      <mat-toolbar-row>
        <button mat-button (click)="onClose()">
          <mat-icon aria-hidden="false" aria-label="Close">close</mat-icon>
          Close
        </button>
        <button mat-button color="warn" (click)="onDelete()">
          <mat-icon aria-hidden="false" aria-label="Delete">delete</mat-icon>
          Delete
        </button>
        <span class="toolbar-spacer"></span>
        <button mat-button [disabled]="!form.dirty" (click)="onReset()">
          <mat-icon aria-hidden="false" aria-label="Cancel">cancel</mat-icon>
          Cancel
        </button>
        <button mat-button [disabled]="!form.valid || !form.dirty" (click)="onSave()">
          <mat-icon aria-hidden="false" aria-label="Save">save</mat-icon> Save
        </button>
      </mat-toolbar-row>
    </mat-toolbar>
    <div class="sections">
      <section>
        <mat-form-field appearance="outline">
          <mat-label>Site Code</mat-label>
          <input matInput formControlName="siteCode" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Site Name</mat-label>
          <input matInput formControlName="siteName" />
        </mat-form-field>
      </section>
    </div>
  </form>
} @else {
  Loading Customer Site...
}
